interface UserState {
  user: any | null;
}

const initialState: UserState = {
  user: {
    FirstName: '',
  },
};

const userReducer = (state = initialState, action: any): UserState => {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload };
    default:
      return state;
  }
};

export default userReducer;
